module.exports = __webpack_public_path__ + "4502b5c164fee8dc37004fda063e00cc.svg";